import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ContentWithCardLoading } from "../../../../components/loading";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import * as accountCampaignPricingWhatsappActions from "../../store/actions/account_campaign_pricing_whatsapp_actions";
import AccountCampaignPricingWhatsappSidePanel from "./components/account-campaign-pricing-whastapp2-side-panel";

const ACCOUNT_CAMPAIGN_PRICING_WHATSAPP_ACTIONS = {
  NONE: "NONE",
  EDIT: "EDIT",
};

export default function AccountCampaignPricingWhatsapp2(props) {
  const [dataToShow, setDataToShow] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  const [selectedPricingWithAction, setSelectedPricingWithAction] = useState({
    action: ACCOUNT_CAMPAIGN_PRICING_WHATSAPP_ACTIONS.NONE,
    data: {},
  });
  const accountCampaignPricingWhatsappList = useSelector((state) => state.accounts.accountCampaignPricingWhatsapp2);
  const params = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(accountCampaignPricingWhatsappActions.getPricingOfAccountWhatsapp2CampaignRequest({ id: params.accountId }));
  }, [dispatch, params.accountId]);

  useEffect(() => {
    if (props.search) {
      const updatedData = accountCampaignPricingWhatsappList.data.filter(each => each.countryName.match(new RegExp(props.search, "gi")))
      const a = updatedData.slice((page - 1) * limit, (page - 1) * limit + limit);
      setDataToShow(a);
    }
    else {
      const updatedData = accountCampaignPricingWhatsappList.data;
      const a = updatedData.slice((page - 1) * limit, (page - 1) * limit + limit);
      setDataToShow(a)

    }
  }, [page, limit, props.search, accountCampaignPricingWhatsappList.data])

  return (
    <>
      {accountCampaignPricingWhatsappList.loading ? (
        <ContentWithCardLoading />
      ) : accountCampaignPricingWhatsappList.data.length === 0 ? (
        "No Data"
      ) : (
        // <CustomEmptyPage
        //   page="blockContact"
        //   setShowAdd={() => {
        //     setShow(true);
        //     setIsEdit(false);
        //   }}
        // />
        <div className={`card card-custom`}>
          <div className="card-body py-3 px-3" style={{ padding: 15 }}>
            <AdvanceDataTable
              columns={[
                { title: "Country Name", apiKeyName: "countryName", fieldInputType: "INPUT" },
                { title: "Country", apiKeyName: "country", fieldInputType: "INPUT" },
                { title: "Category", apiKeyName: "route", fieldInputType: "INPUT" },
                { title: "Price", apiKeyName: "price", fieldInputType: "INPUT" },
                { title: "Additional Price", apiKeyName: "additionalPrice", fieldInputType: "INPUT" },
                { title: "Final Price", apiKeyName: "finalPrice", fieldInputType: "INPUT" },
                { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },
                { title: "Action", isAction: true, options: ["edit"] },
              ]}
              data={dataToShow.map((each) => ({
                ...each,
                finalPrice: ((each.additionalPrice || 0) + (each.price || 0)).toFixed(4),
              }))}
              limit={limit}
              pageNo={page}
              setPageNo={setPage}
              setLimit={setLimit}
              count={accountCampaignPricingWhatsappList.data.length}
              // actions
              handleEdit={(data) => setSelectedPricingWithAction({ action: ACCOUNT_CAMPAIGN_PRICING_WHATSAPP_ACTIONS.EDIT, data })}
            />
          </div>
        </div>
      )}

      <AccountCampaignPricingWhatsappSidePanel
        show={selectedPricingWithAction.action === ACCOUNT_CAMPAIGN_PRICING_WHATSAPP_ACTIONS.EDIT}
        pricingData={selectedPricingWithAction.data}
        handleClose={() => setSelectedPricingWithAction({ action: ACCOUNT_CAMPAIGN_PRICING_WHATSAPP_ACTIONS.NONE, data: {} })}
      />
    </>
  );
}
